import moment from 'moment-timezone';

// ── Formato de fecha a zona horaria del usuario (sessionStorage) ──

export function getUserTz() {
    return sessionStorage.getItem('tz') || 'America/Santiago';
}

export function formatTzShort(timestamp) {
    return moment(timestamp).tz(getUserTz()).format('DD/MM HH:mm');
}

export function formatTzFull(timestamp) {
    return moment(timestamp).tz(getUserTz()).format('YYYY-MM-DD HH:mm:ss');
}

// ── Normalización y cálculos ──

export function normalizeMos(raw) {
    if (raw == null) return 0;
    return raw > 5 ? raw / 20 : raw;
}

export function calcAvg(values) {
    const valid = values.filter(v => v != null);
    if (!valid.length) return 0;
    return valid.reduce((s, v) => s + v, 0) / valid.length;
}

export function calcP95(values) {
    const valid = values.filter(v => v != null);
    if (!valid.length) return 0;
    const sorted = [...valid].sort((a, b) => a - b);
    return sorted[Math.floor(0.95 * sorted.length)] ?? sorted[sorted.length - 1];
}

// ── Clasificación de calidad ──

export function getMosQuality(mos, t) {
    if (mos >= 4.0) return { label: t('cqp.quality.excellent'), color: '#41B900' };
    if (mos >= 3.5) return { label: t('cqp.quality.good'), color: '#FFC600' };
    if (mos >= 3.0) return { label: t('cqp.quality.acceptable'), color: '#FF7E00' };
    if (mos >= 2.0) return { label: t('cqp.quality.poor'), color: '#C2272D' };
    return { label: t('cqp.quality.critical'), color: '#8B0000' };
}

export function getJitterColor(v) {
    if (v < 20) return '#41B900';
    if (v <= 30) return '#FFC600';
    return '#C2272D';
}

export function getJitterQuality(v, t) {
    if (v < 20) return { label: t('cqp.jitter.normal'), color: '#41B900' };
    if (v <= 30) return { label: t('cqp.jitter.warning'), color: '#FFC600' };
    return { label: t('cqp.jitter.degraded'), color: '#C2272D' };
}

export function getPacketLossColor(v) {
    if (v < 1) return '#41B900';
    if (v <= 3) return '#FFC600';
    return '#C2272D';
}

export function getPacketLossQuality(v, t) {
    if (v < 1) return { label: t('cqp.lp.normal'), color: '#41B900' };
    if (v <= 3) return { label: t('cqp.lp.risk'), color: '#FFC600' };
    return { label: t('cqp.lp.critical'), color: '#C2272D' };
}

export function getMesQuality(v, t) {
    if (v >= 4.0) return { label: t('cqp.quality.excellent'), color: '#41B900' };
    if (v >= 3.5) return { label: t('cqp.quality.good'), color: '#FFC600' };
    if (v >= 3.0) return { label: t('cqp.quality.acceptable'), color: '#FF7E00' };
    if (v >= 2.0) return { label: t('cqp.quality.poor'), color: '#C2272D' };
    return { label: t('cqp.quality.critical'), color: '#8B0000' };
}

export function formatTime(seconds) {
    if (!seconds || isNaN(seconds)) return '0:00';
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${String(s).padStart(2, '0')}`;
}
